import { TipoDocumento } from '../constants/TipoDocumento'

export function limpaDocumento (str) {
    return str.replace(/\D/g, '');
}

export function validateCPF(str) {
    str = limpaDocumento(str);

    if (str.length != 11) {
        return false;
    }

    let digitos_iguais = 0, soma = 0, resto
    for (let i = 0; i < str.length - 1; i++)
        if (str.charAt(i) == str.charAt(i + 1)) {
            digitos_iguais++;
        }
    if (digitos_iguais == str.length) {
        return false;
    }

    for (let i = 1; i <= 9; i++) {
        soma = soma + parseInt(str.substring(i - 1, i)) * (11 - i);
    }

    resto = (soma * 10) % 11;

    if ((resto == 10) || (resto == 11)) {
        resto = 0;
    }

    if (resto != parseInt(str.substring(9, 10))) {
        return false;
    }

    soma = 0;

    for (let i = 1; i <= 10; i++) {
        soma = soma + parseInt(str.substring(i - 1, i)) * (12 - i);
    }

    resto = (soma * 10) % 11;

    if ((resto == 10) || (resto == 11)) {
        resto = 0;
    }

    if (resto != parseInt(str.substring(10, 11))) {
        return false;
    }

    return true;
}

export function validateCNPJ(str) {
    str = limpaDocumento(str);

    let cnpj = str, numeros, digitos, soma, i, resultado, pos, tamanho, digitos_iguais = 1;

    if (cnpj.length != 14) {
        return false;
    }

    for (let i = 0; i < cnpj.length - 1; i++) {
        if (cnpj.charAt(i) != cnpj.charAt(i + 1)) {
            digitos_iguais = 0;
            break;
        }
    }

    if (!digitos_iguais) {
        tamanho = cnpj.length - 2
        numeros = cnpj.substring(0, tamanho);
        digitos = cnpj.substring(tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) {
                pos = 9;
            }
        }

        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0)) {
            return false;
        }

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) {
                pos = 9;
            }
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1)) {
            return false;
        }
        return true;
    }
    else {
        return false;
    }
}

export function isDocumentoCPF(str) {
    return (limpaDocumento(str).length === 11);
}

export function isDocumentoCNPJ(str) {
    return (limpaDocumento(str).length === 14);
}

export function validateTipoDocumento(str) {
    str = limpaDocumento(str);
    if(isDocumentoCPF(str)) return TipoDocumento.CPF;
    if(isDocumentoCNPJ(str)) return TipoDocumento.CNPJ;
    return TipoDocumento.INVALID;
}

export function validateDocumento(str) {
    var tipoDocumento = validateTipoDocumento(str);
    if(tipoDocumento === TipoDocumento.INVALID) return false;
    if(tipoDocumento === TipoDocumento.CPF) return validateCPF(str);
    if(tipoDocumento === TipoDocumento.CNPJ) return validateCNPJ(str);
    return false;
}
